import React from 'react';
import { Grid } from '@mui/material';

import { useFormState } from 'shared/hooks';
import useConsultData from 'features/consults/hooks/useConsultData';
import GridWrapper from 'shared/components/layout/GridWrapper/GridWrapper';
import QuestionsPanel from 'features/consults/components/tabFields/QuestionsPanel';

import useConsultInitialFormState from 'features/consults/hooks/useConsultInitialFormState';
import { CONSULT_TABS } from 'features/consults/utils/constants';
import schema from './validationSchema';
import { leftPanel, rightPanel } from './data';

const PMHFHSH = () => {
  const { register, control, getFieldError, getValues, setFormValues } =
    useFormState(schema, { stateSlice: 'consults', showAsSnackbar: true });
  const {
    consult,
    consultMainType,
    consultTabData,
    isEditable,
    handleFieldChange,
  } = useConsultData(CONSULT_TABS.PMH, getValues);

  useConsultInitialFormState(consult.id, consultTabData, setFormValues);

  return (
    <GridWrapper>
      <Grid item xs={12} lg={6}>
        <QuestionsPanel
          control={control}
          register={register}
          getFieldError={getFieldError}
          onChange={handleFieldChange}
          disabled={!isEditable}
          {...leftPanel(consultMainType)}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <QuestionsPanel
          control={control}
          register={register}
          getFieldError={getFieldError}
          onChange={handleFieldChange}
          disabled={!isEditable}
          {...rightPanel(consultMainType)}
        />
      </Grid>
    </GridWrapper>
  );
};

export default PMHFHSH;
